/**
 * StudentQuestDetailScreen — le détail d'une quête (route `skill-sets`, `?skillSetId=`), à la place
 * de `student/progress/my progress/MyProgressScreen.js` quand l'espace élève est allumé.
 *
 * Patron C (cache seul), comme l'ancien écran : la quête est lue dans le compte, aucune lecture ne
 * part (`studentQuestDetailViewModel`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentQuestDetailPage } from "../../../../../../design-system/student"
import {
    questDetailIdOf,
    studentQuestDetailViewModel,
} from "../../../../view-models/student/Game/studentQuestDetailViewModel"
import { type StudentSpaceScreenProps } from "../studentSpaceRouteTypes"
import { useStudentQuestDetailState } from "./useStudentGameState"

export function StudentQuestDetailScreen(props: StudentSpaceScreenProps) {
    const skillSetId = questDetailIdOf(props.route?.params)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => studentQuestDetailViewModel(state, skillSetId))
    const state = useStudentQuestDetailState()

    return <StudentQuestDetailPage detail={vm.detail} loading={vm.loading} {...state} />
}
